import { render, staticRenderFns } from "./ResherSiper2.vue?vue&type=template&id=3d06c608&scoped=true"
import script from "./ResherSiper2.vue?vue&type=script&lang=js"
export * from "./ResherSiper2.vue?vue&type=script&lang=js"
import style0 from "./ResherSiper2.vue?vue&type=style&index=0&id=3d06c608&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d06c608",
  null
  
)

export default component.exports